import { render } from "./associateUserToBranch.vue?vue&type=template&id=3572aec0&scoped=true"
import script from "./associateUserToBranch.vue?vue&type=script&lang=js"
export * from "./associateUserToBranch.vue?vue&type=script&lang=js"

import "./associateUserToBranch.vue?vue&type=style&index=0&id=3572aec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3572aec0"]])

export default __exports__